import React, { useState } from 'react';
import LocalizationKeyPicker from './LocalizationKeyPicker';

/** Purpose: bind message content to an optional localization key. Why: authors need to choose translated text while preserving manual content fallback. */
export default function LocalizedContent({ localizationKey = '', localizationKeys = [], onKeyChange, selectClass, children }) {
  const [selectingKey, setSelectingKey] = useState(false);
  return <div className="space-y-2">
    <div className="flex justify-end gap-2">
      <button type="button" aria-label="Configure localization key" aria-expanded={selectingKey || Boolean(localizationKey)}
        title="Use a localization key" onClick={() => setSelectingKey((open) => !open)}
        className="max-w-full truncate rounded-md px-2 py-1 text-xs font-medium text-cyan-700 hover:bg-cyan-50 dark:text-cyan-300 dark:hover:bg-white/5">
        🌐 {localizationKey || 'Key'}
      </button>
      {localizationKey && <button type="button" aria-label="Clear localization key" title="Use normal text" className="px-1 text-slate-500" onClick={() => { onKeyChange(''); setSelectingKey(false); }}>×</button>}
    </div>
    {(selectingKey || localizationKey) && <>
      <LocalizationKeyPicker
        label="Content localization key"
        normalTextLabel="Normal text (no key)"
        localizationKey={localizationKey}
        localizationKeys={localizationKeys}
        selectClass={selectClass}
        onKeyChange={(key) => { onKeyChange(key); setSelectingKey(false); }}
      />
      {!localizationKeys.length && <p className="text-xs text-amber-600">Create keys in Orchestration → Localization.</p>}
    </>}
    <div hidden={Boolean(localizationKey)}>{children}</div>
  </div>;
}
